module.exports = {"pageTitleText":"Cache Clear","addBtnText":"Clear Cache"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/en-US/cacheclear.json
// module id = bxEe
// module chunks = 3